import { Link } from "react-router-dom";
import { formatNumber } from "../../../../utils/utils";
import { getMaterialsBudget, getServiceBudget } from "./linked-projects.utils";

export const linkedProjectPlansColumns = (totalServices, totalMaterials, totalSum) => {
  return [
    {
      name: "Plan Name",
      dataKey: "projectName",
      width: "25%",
      align: "left",
      render: (cellData, rowData) => (
        <Link to={`/projectsview/${rowData.id}/details?isGroupView=false`} style={{ textDecoration: "underline", color: "inherit" }}>
          {cellData}
        </Link>
      ),
      sortable: true,
    },
    {
      name: "Start",
      dataKey: "start",
      width: "10%",
      align: "left",
      sortable: true,
    },
    {
      name: "State",
      dataKey: "state",
      width: "10%",
      align: "left",
      footer: "Totals",
      sortable: true,
    },
    {
      name: "Services",
      dataKey: "plannerServiceValue",
      width: "15%",
      align: "left",
      sortAccessor: (row) => getServiceBudget(row),
      render: (_cellData, rowData) => `$ ${formatNumber(getServiceBudget(rowData))}`,
      footer: `$ ${formatNumber(totalServices)}`,
      sortable: true,
    },
    {
      name: "Materials",
      dataKey: "materials",
      width: "15%",
      align: "left",
      sortAccessor: (row) => getMaterialsBudget(row.materials),
      render: (_cellData, rowData) =>
        `$ ${formatNumber(getMaterialsBudget(rowData.materials))}`,
      footer: `$ ${formatNumber(totalMaterials)}`,
      sortable: true,
    },
    {
      name: "Total",
      dataKey: "",
      width: "15%",
      align: "left",
      render: (_cellData, rowData) =>
        `$ ${formatNumber(parseFloat(rowData.projectTotal) || 0)}`,
      footer: `$ ${formatNumber(totalSum)}`,
      sortable: true,
    },
  ];
};
